/* global axios */
import ApiClient from './ApiClient';

class WahaInboxesAPI extends ApiClient {
  constructor() {
    super('waha_inboxes', { accountScoped: true });
  }

  create(inboxData) {
    return axios.post(this.url, inboxData);
  }
}

export default new WahaInboxesAPI();
